/**
 * usePublicLinkPage.js : hooks des pages publiques des liens de séance (D247)
 * et de comparaison (D257), extraits de PublicSessionLinkPage.
 */
import { useEffect, useState } from 'react';
import { readTokenFromHash } from './publicSessionLinkService';

/** Page non indexée : balise posée tant que la page est montée (l'en-tête X-Robots-Tag la double côté serveur). */
export function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
}

/** Jeton du fragment, relu si le fragment change (lien collé dans le même onglet). */
export function useHashToken() {
  const [token, setToken] = useState(() => readTokenFromHash(window.location.hash));
  useEffect(() => {
    const onHash = () => setToken(readTokenFromHash(window.location.hash));
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);
  return token;
}
